import { jwtDecode } from "jwt-decode";
import React, { useState } from "react";
import { BsInfoCircleFill } from "react-icons/bs";
import { useHistory } from "react-router-dom";
import popularIcon from "../../../../assets/elements/popular_icon.png";
import { isUserRestrictedForPlan, NETWORK3_VENDOR, PLAN_TYPE_LOCAL, WEBSITE_SOURCE_ID } from "../../../../Common/Constant";
import DashboardDetailsService from "../../../../Services/DashboardDetailsService";
import SanctionCountry from "../../../../Services/SanctionCountry";
import UserVarificationService from "../../../../Services/UserVarificationService";
import AlertPopup from "../../../Alert_Popup/AlertPopup";
import Loader from "../../../Alert_Popup/Loader";
import getSubPlanList from "../../../Common/getSubPlanList";
import { useTheme } from "../../../Common/Theme/ThemeProvider";
import getUserCurrentLocationDetails from "../../../Common/getUserCurrentLocationDetails";

const PlanCard = ({
  data,
  recurringModal,
  setRecurringModal,
  setModalData,
  setCurrentDetails,
  setDetailsOpen,
  setSubPlan,
  subPlan,
  isTopPlan,
  vendorId,
}) => {
  const { theme, toggleTheme } = useTheme();
  const [message, setMessage] = useState();
  const [showLogin, setShowLoginPopUp] = useState(false);
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSanction, setIsSanction] = useState(false);
  const [showSanctionPopup, setShowSanctionPopup] = useState(false);
  const [isRestrictedLocation, setIsRestrictedLocation] = useState(false);
  const [restrictedLocationCountryName, setRestrictedLocationCountryName] = useState(false);

  const history = useHistory();

  const handleDetailsOpen = (data) => {
    console.log("datadatadata", data);
    setDetailsOpen(true);
    setCurrentDetails(data);
  };

  // useEffect(() => {
  //   console.log("datadatadata", data);
  // }, []);

  const updateLoginPopupStatus = () => {
    setShowLoginPopUp(false);
  };

  const updateSanctionPopupStatus = () => {
    setIsSanction(false);
  }

  const updateRestrictedPopupStatus = () => {
    setIsRestrictedLocation(false);
  }

  const RestrictedCtaBtn = () => {
    return (
      <button
        className="btn rounded-pill font-weight-bold text-uppercase btn-dark custom-width-btn btn-md mt-2 mb-1"
        onClick={updateRestrictedPopupStatus}
      >
        <font>Ok</font>
      </button>
    );
  }

  const SanctionCtaBtn = () => {
    return (
      <button
        className="btn rounded-pill font-weight-bold text-uppercase btn-dark custom-width-btn btn-md mt-2 mb-1"
        onClick={updateSanctionPopupStatus}
      >
        <font>Ok</font>
      </button>
    );
  }
  const LoginCtaBtn = () => {
    return (
      <button
        className="btn rounded-pill font-weight-bold text-uppercase btn-dark custom-width-btn btn-md mt-2 mb-1"
        onClick={loginClicked}
      >
        <font>LOGIN</font>
      </button>
    );
  };

  const ResendEmailBtn = () => {
    return (
      <button
        className="btn rounded-pill font-weight-bold text-uppercase btn-dark custom-width-btn btn-md mt-2 mb-1 notranslate"
        onClick={resendClicked}
      >
        RESEND EMAIL
      </button>
    );
  };

  const loginClicked = () => {
    history.push(`/login`);
  };

  const updateVarificationPopupStatus = () => {
    setShowVerifyPopup(false);
  };

  const resendClicked = () => {
    const revarification = localStorage.getItem("emailId");
    UserVarificationService.resendVerificationLink(revarification).then(
      (response) => {
        if (response.status == 200) {
          setShowVerifyPopup(false);
        }
      }
    );
  };

  const SanctionClick = async (data) => {
    const email = localStorage.getItem("emailId");
    console.log("data I am getting =>", data);
    console.log("data I am IP =>", data.vendor.vendorId === 4);
    console.log("data I am getting 2 =>", data.planCountry[0]?.countryDescription);
    const isSanctioned = data.planCountry[0]?.sanction;
    if (isSanctioned && data.vendor.vendorId === 4 && (!email || email === "" || email === undefined || email === null)) {
      if (typeof window.gtag === "function") {
        console.log("Google Analytics is initialized 1");
        window.gtag("event", "click", {
          event_category: "Button",
          event_label: `Buy Now Clicked without login ${localStorage.getItem("ip")}`,
          sanctionCountry_ip: `${data.planCountry[0]?.countryDescription}_${localStorage.getItem("ip")}`,
          sanctionCountry: data.planCountry[0]?.countryDescription,
          value: 1,
          user: localStorage.getItem("ip"),
          debug_mode: true,
          config: "G-CNPPGN8KCG",
          js: new Date(),
        });
        console.log("Google Analytics is initialized 2");
      } else {
        console.log("Google Analytics is not initialized.");
      }
    }
    console.log("here now");
  }

  const buyNowClicked = async (data1) => {
    setIsLoading(true);
    //check user verification
    // Check user verification status in local storage
    const email = localStorage.getItem("emailId");
    //console.log("email", email);

    if (!email || email === "" || email === undefined || email === null) {
      setIsLoading(false);
      setShowLoginPopUp(true);
    } else if (email || email !== "" || email !== undefined) {
      // var userVerificationStatus = localStorage.getItem("userVerificationStatus");
      // if(localStorage.getItem("userVerificationStatus") == 0){
      if (localStorage.getItem("token")) {
        const token = localStorage.getItem("token");
        const user = jwtDecode(token);
        const exp = user.exp;
        const currentTime = Math.floor(Date.now() / 1000);
        if (exp < currentTime) {
          setIsLoading(false);
          localStorage.clear();
          history.push("/");
        }
        await UserVarificationService.getVerificationStatus(
          localStorage.getItem("userId")
        ).then(async (response) => {
          if (response.status == 200) {
            // localStorage.setItem("userVerificationStatus", response.data);
            const userVerificationStatus = response.data;
            if (!userVerificationStatus || userVerificationStatus === "0") {
              // Show popup for unverified us
              setIsLoading(false);
              setShowVerifyPopup(true);
            } else if (
              userVerificationStatus ||
              userVerificationStatus === "1"
            ) {
              // User is verified
              await DashboardDetailsService.dashboardDetailService(
                localStorage.getItem("userId")
              ).then(async (response) => {
                if (response.status === 200) {
                  var country = await getUserCurrentLocationDetails();
                  const isRestricted = data1.planType.planTypeId == PLAN_TYPE_LOCAL && isUserRestrictedForPlan(country.countryCode, data1?.country?.alpha2)
                  if (isRestricted) {
                    setIsRestrictedLocation(true);
                    setRestrictedLocationCountryName(country.countryName)
                  } else if (data1.vendor.vendorId == NETWORK3_VENDOR && data1.planType.planTypeId == PLAN_TYPE_LOCAL && data1.planCountry[0].sanction) {
                    setIsRestrictedLocation(false);
                    addSanctionPlanCountry(data1.planId)
                  } else {
                    var subPlanDetails = await getSubPlanList(data1);
                    if (subPlanDetails != null) {
                      setSubPlan(subPlanDetails.subPlanList);
                      if (subPlanDetails.subPlanList.length === 0) {
                        setMessage("No Plans Available");
                        setRecurringModal(false);
                        setIsLoading(false);
                        localStorage.setItem("plan", JSON.stringify(data1));
                        if (!isTopPlan) {
                          localStorage.removeItem("topUpIccid");
                          localStorage.removeItem("topUpList");
                        }
                        history.push({
                          pathname: "/OrderSummary",
                        });
                      } else {
                        setIsLoading(false);
                        setModalData(data1);
                        setRecurringModal(true);
                      }
                    }
                  }
                }
              });
              setIsLoading(false);
            }
          }
        });
      } else {
        setIsLoading(false);
        localStorage.clear();
        history.push("/");
      }
      setIsLoading(false);
    }
  };

  const addSanctionPlanCountry = async (planId) => {
    setIsLoading(true);
    setIsSanction(true);
    await SanctionCountry.addSanctionCountryLog(
      localStorage.getItem("userId"),
      planId,
      WEBSITE_SOURCE_ID//sourceId
    ).then(async (response) => {
    })
      .catch((error) => {
        if (error.message === "Network Error") {
          setMessage(error.message);
        } else {
          switch (error.response ? error.response.status : "") {
            case 401:
              break;
            case 403:
              break;
            case 500:
            case 404:
            case 406:
              break;
            case 412:
              break;
            default:
              setMessage("Unknown Error");

              break;
          }
        }
      });
    setIsLoading(false);
  };

  return (
    <>
      <div
        className={`${data.isPopularIndex ? "card-ticket popular-sticker" : "card-ticket"
          } notranslate`}
      >
        {data.isPopularIndex && (
          <div className="golden-label d-flex align-items-center">
            <img
              className="mr-1"
              style={{ width: "16px" }}
              src={popularIcon}
              alt="popular"
            />
            <span className="d-inline-block text-truncate number">
              {"Popular #" + (data.itemIndex + 1)}
            </span>
          </div>
        )}
        <h2 className="number mt-1 mb-0 plan-detail notranslate">
          {data.data}
        </h2>
        {/* <div className="w-100 d-flex align-ietms-center justify-content-between" style={{gap: 6}}> */}
        {/* {data.country ? <p className="m-0 notranslate" style={{width: '100px', textAlign: 'end', fontSize: '12px', marginTop: 4}}>{data.country.countryDescription}</p> : */}
        {/* data.planCountry ? <p className="m-0 notranslate" style={{width: '100px', textAlign: 'end', fontSize: '12px', marginTop: 4}}>{data.planCountry.length} {data.planCountry.length > 1 ? "Countries": "Country" }</p> : null } */}
        {/* </div> */}
        <p className="number">
          {data.planName}
        </p>
        <div
          style={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: "1fr 0.1fr 1fr 0.1fr 1fr",
            justifyContent: "center",
            alignItems: "center",
          }}
          className="mt-2"
        >
          <div className="plan-validity px-2 text-center">
            <p className="number card-content">
              {data.validity + " " + (data.validity == 1 ? "Day" : "Days")}{" "}
            </p>
            <p className="muted-text">validity</p>
          </div>
          <div className="line-seperator"></div>
          <div className="plan-price px-2 text-center">
            <p className="number card-content">
              £{Number(data.price).toFixed(0)}
            </p>
            <p className="muted-text">price</p>
          </div>
          <div className="line-seperator"></div>
          <div className="plan-price px-2 d-flex flex-column justify-content-center align-items-center text-center">
            {data.planCountry ? (
              <p
                onClick={() => handleDetailsOpen(data)}
                className="mb-0 notranslate info-icon"
              >
                <BsInfoCircleFill />
                <span className="number">{data.planCountry.length}</span>
              </p>
            ) : null}
            <p className="muted-text">
              {data.planCountry.length > 1 ? "Countries" : "Country"}
            </p>
          </div>
        </div>
        <button
          // onClick={() => (data.vendor.vendorId == NETWORK3_VENDOR && data.planType.planTypeId == PLAN_TYPE_LOCAL && data.planCountry[0].sanction) ? addSanctionPlanCountry(data.planId) : buyNowClicked(data)}
          onClick={() => { buyNowClicked(data); SanctionClick(data) }}
          className={`btn notranslate ${theme === "light" ? "btn-dark" : "btn-light"}`}
        >
          BUY NOW
        </button>
      </div>
      {showVerifyPopup && (
        <AlertPopup
          status={"warning"}
          note={
            "Note* If account is verified then please sign out and sign in again."
          }
          heading={"To proceed please verify your account"}
          content={"Verification link sent to your registered email address."}
          customFunction={<ResendEmailBtn />}
          updateState={updateVarificationPopupStatus}
        />
      )}
      {showLogin && (
        <AlertPopup
          status={"warning"}
          heading={"Login required to proceed"}
          content={"To gain full access please Login"}
          customFunction={<LoginCtaBtn />}
          updateState={updateLoginPopupStatus}
        />
      )}
      {isSanction && (
        <AlertPopup
          status={"warning"}
          heading={"Sanction Country"}
          content={"This country is on the sanction list, currently it is not available for purchase."}
          customFunction={<SanctionCtaBtn />}
          updateState={updateSanctionPopupStatus}
        />
      )}
      {isRestrictedLocation && (
        <AlertPopup
          status={"warning"}
          heading={"Restricted Location"}
          content={restrictedLocationCountryName + " plan purchase is not allowed from your current location (" + restrictedLocationCountryName + ")."}
          customFunction={<RestrictedCtaBtn />}
          updateState={updateRestrictedPopupStatus}
        />
      )}
      {isLoading === true && <Loader />}
    </>
  );
};

export default PlanCard;
